import type { ContributorDto } from '@/types/dtos/contributors/response/contributor.dto';

/** Clerk `userId` matches the contributor once they are linked to a platform user. */
export function isContributorLinkedToClerkUser(
  contributor: ContributorDto | undefined,
  clerkUserId: string | null | undefined,
): boolean {
  if (!clerkUserId || !contributor) return false;
  if (contributor.user?.id === clerkUserId) return true;
  if (contributor.userContributor?.user?.id === clerkUserId) return true;
  return false;
}
